import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a8980f1&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8980f1')) {
      api.createRecord('6a8980f1', component.options)
    } else {
      api.reload('6a8980f1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a8980f1&", function () {
      api.rerender('6a8980f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/editor/index.vue"
export default component.exports